
<template>
  <div class="ph-compare-page ph-compare-add-page">
    <top-bar ref="topBarRef" title="Product Comparison" ></top-bar>
    <!-- 操作栏 -->
    <action-bar ref="actionBarRef" @showAddProduct="showAddProduct" @showSearch="showSearch" @input="setKeyWord" :search="true"></action-bar>

    <ul class="infinite-list" ref="infiniteList" v-infinite-scroll="getList" :infinite-scroll-distance="bottomBarHeight * 2" :style="{height: infiniteHeight + 'px', paddingBottom: bottomBarHeight + 'px'}">
      <li v-for="(item, index) in list" :key="index" class="infinite-list-item">
        <div class="product-item">
          <el-checkbox v-model="item.checked" class="product-checkbox" @change="changeProduct" :disabled="disabledIds.includes(item.id)"></el-checkbox>
          <div class="product-image" @click="toggleProduct(item)">
            <img :src="item.compare_image" alt="">
          </div>
          <div class="product-info" @click="toggleProduct(item)">
            <div class="product-name">{{item.name}}</div>
            <div class="product-category">{{item.compare_category ? item.compare_category.en_name : '-'}}</div>
          </div>
        </div>
      </li>
    </ul>

        <div class="bottom-bar" ref="bottomBarRef">
          <div class="compare-btn" @click="startCompare">
            Compare（{{checkedCount}}）
          </div>
        </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import topBar from "./components/top-bar.vue";
import actionBar from "./components/action-bar.vue";

export default {
  components: {actionBar, topBar},
  props:{
    footerHeight: {
      type: Number,
      default: 0
    },
    headerHeight: {
      type: Number,
      default: 0
    }
  },
  data(){
    return {
      list: [],
      infiniteHeight: 0,
      bottomBarHeight: 0,
      loading: false,
      isEnd: false,
      isAllSelected:false,
      params: {
        channel_id: 1,
        cid: '',
        lang: 'cn',
        page: 0,
        pageSize: 10,
        mold: 'h5',
        keyword: '',
        is_compare: 1,
      },
      selectProducts: [],
      disabledIds: [],
    }
  },
  computed: {
    checkedCount() {
      return this.selectProducts.length
    },
    ...mapState(['compare'])
  },
  mounted() {
    const _this = this
    this.params.compare_category_id = this.compare.category_id
    _this.list = []
    this.$nextTick(() => {
      _this.bottomBarHeight = _this.$refs.bottomBarRef.offsetHeight
      _this.infiniteHeight = window.innerHeight - _this.headerHeight - _this.$refs.topBarRef.$el.offsetHeight - _this.$refs.actionBarRef.$el.offsetHeight - _this.bottomBarHeight - 10
      _this.selectProducts = this.compare.products
    })
  },
  methods: {
    deleteSelected() {
      const selectedProducts = this.compareProducts.filter(item => item.selected)

      if (selectedProducts.length === 0) {
        this.$message.warning('请选择要对比的产品')
        return
      }

      const saveProducts = this.compareProducts.filter(item => !item.selected)

      this.$store.commit('saveCompareProducts', saveProducts)


      // this.$confirm(`确定删除 ${selectedProducts.length} 个产品？`, '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   const newProducts = this.compareProducts.filter(item => !item.selected)
      //   this.$store.commit('setCompareProducts', newProducts)
      //   this.$message.success('删除成功')
      // }).catch(() => {
      // })
    },
    toggleSelectAll() {
      // const isSelected = !this.isAllSelected
      // this.compareProducts.forEach(item => {
      //   this.$set(item, 'selected', isSelected)
      // })

      // const isSelected = !this.isAllSelected
      this.list.forEach(item => {
        item.checked = true
      })
      this.selectProducts = this.list
      this.showAddProduct()
    },
    setKeyWord(keyword){
      this.params.keyword = keyword
      this.list = []
      this.params.page = 0
      this.isEnd = false
      this.getList()
    },
    changeProduct(value){
      this.selectProducts = this.list.filter(item => item.checked)
    },
    toggleProduct(item){
      if(this.disabledIds.includes(item.id)) return
      item.checked = !item.checked
      this.selectProducts = this.list.filter(item => item.checked)
    },
    getList(){
      const _this = this
      if (_this.loading || _this.isEnd) return
      _this.loading = true
      _this.params.page += 1
      _this.$api.get_product_list(_this.params).then(res => {
        res.data.data.forEach(item => {
          item.checked = false
          _this.compare.products.forEach(product => {
            if (item.id == product.id) {
              item.checked = true
              this.disabledIds.push(item.id)
            }
          })
        })
        _this.list = _this.list.concat(res.data.data)
        if(res.data.total == _this.list.length){
          _this.isEnd = true
        }
        _this.loading = false
      })
    },
    startCompare() {
      this.showAddProduct()
      this.$router.push('/ph/compare')
    },
    goBack() {
      this.$router.back();
    },
    showAddProduct() {
      let checkedProducts = this.list.filter(item => item.checked)
      if(!checkedProducts.length) return;
      // if(this.compare.products.length){
      //   checkedProducts = checkedProducts.concat(this.compare.products)
      // }
      checkedProducts = checkedProducts.filter((item, index) => checkedProducts.findIndex(i => i.id === item.id) === index);
      this.$store.commit('saveCompareProducts', checkedProducts)
    },
    showSearch() {
      this.$emit('showSearch');
    }
  }
}
</script>

<style scoped>
@import "../../style/compare.css";

.infinite-list {
  list-style: none;
  padding: 0 0.4rem;
  margin: 0;
  background: #fff;
  overflow:auto;
}

.product-list-wrapper {

}

.infinite-list .infinite-list-item {
  list-style: none;
  background: #fff;
  border-bottom: 1px solid #dcdcdc;
}

.product-item {
  display: flex;
  align-items: center;
  padding: .26rem 0;
}

.product-checkbox {
  margin-right: .4rem;
}

.product-image {
  width: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.24rem;
  flex-shrink: 0;
}

.product-image img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.product-info {
  flex: 1;
  min-width: 0;
}

.product-name {
  font-size: 0.32rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.12rem;
}

.product-category {
  font-size: 0.24rem;
  color: #666;
}


.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.2rem 0.32rem;
  background: #fff;
  z-index: 999;
}


.compare-btn {
  height: 0.88rem;
  background: #f0252d;
  color: #fff;
  font-size: 0.28rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.12rem;
  cursor: pointer;
}

.compare-btn:active {
  opacity: 0.8;
}
</style>

<style>
/*.infinite-list .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #f0252d ;
  border-color: #f0252d ;
}

.infinite-list .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #f0252d;
}

.infinite-list .el-checkbox__inner:hover {
  border-color: #f0252d;
}*/

.ph-compare-add-page .infinite-list .el-checkbox__input.is-checked .el-checkbox__inner,
.ph-compare-add-page .infinite-list .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #f0252d ;
  border-color: #f0252d ;
}
.ph-compare-add-page .infinite-list .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #F2F6FC;
  border-color: #DCDFE6;
}
</style>